<template lang="pug">
#modal-contratos-en-lote-ar
    el-dialog.modal-contratos-en-lote-ar(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        append-to-body,
        custom-class='modal-contratos-en-lote-ar-content',
        width='90%',
        @close='fecharModal'
    )
        span(slot='title')
            h3
                b Contratos En Lote AR

        .modal-contratos-en-lote-ar__body
            el-alert(
                title='Revise os contratos alocados abaixo e confirme o processamento dos volumes.',
                type='info',
                show-icon,
                :closable='false'
            )

            el-table(
                :data='contratos',
                border,
                stripe,
                style='width: 100%'
            )
                el-table-column(type='expand', width='50')
                    template(slot-scope='scope')
                        .territorios-vinculados__empty(v-if='!scope.row.territorios || !scope.row.territorios.length')
                            span Nenhum território vinculado
                        .territorios-vinculados(v-else)
                            .territorios-vinculados__header
                                i.mdi.mdi-map-marker
                                span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.resumoContratos.territoriosVinculados') }}
                            el-table(
                                :data='scope.row.territorios',
                                size='mini',
                                style='width: 100%'
                            )
                                el-table-column(
                                    :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.resumoContratos.colRenspa")',
                                    prop='renspa',
                                    min-width='160'
                                )
                                    template(slot-scope='sub') {{ sub.row.renspa || '-' }}
                                el-table-column(
                                    :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.resumoContratos.colCuit")',
                                    prop='cuit',
                                    min-width='140'
                                )
                                    template(slot-scope='sub') {{ sub.row.cuit || '-' }}
                                el-table-column(
                                    :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.resumoContratos.colVolumenReportado")',
                                    min-width='160',
                                    align='right'
                                )
                                    template(slot-scope='sub') {{ sub.row.volumeReportado != null ? formatarVolume(sub.row.volumeReportado) : '-' }}
                                el-table-column(
                                    :label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.resumoContratos.colAnalisisElegibilidad")',
                                    min-width='180',
                                    align='center'
                                )
                                    template(slot-scope='sub')
                                        el-tag(
                                            :type='tipoTagElegibilidade(sub.row.statusElegibilidadeCodigo)',
                                            size='small'
                                        ) {{ sub.row.statusElegibilidade || '-' }}

                el-table-column(:label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.contratosEnLote.colNumeroContrato")', width='130', align='center')
                    template(slot-scope='scope') {{ scope.row.numeroContrato || '-' }}

                el-table-column(label='Cultivo', min-width='100')
                    template(slot-scope='scope') {{ scope.row.cultivo || '-' }}

                el-table-column(label='Cosecha', width='90', align='center')
                    template(slot-scope='scope') {{ scope.row.cosecha || '-' }}

                el-table-column(label='Vol. Contratado (t)', min-width='150', align='right')
                    template(slot-scope='scope') {{ scope.row.volumeContratado != null ? formatarVolume(scope.row.volumeContratado) : '-' }}

                el-table-column(label='Vol. Alocado (t)', min-width='130', align='right')
                    template(slot-scope='scope') {{ scope.row.volumeAlocado != null ? formatarVolume(scope.row.volumeAlocado) : '-' }}

                el-table-column(label='Status Previsto', min-width='210')
                    template(slot-scope='scope')
                        el-tag(
                            :type='tipoTagStatus(scope.row.statusPreview)',
                            size='small'
                        ) {{ scope.row.statusPreviewDescricao || scope.row.statusPreview || '-' }}

                el-table-column(label='Elegibilidade', width='140', align='center')
                    template(slot-scope='scope')
                        el-tag(
                            :type='scope.row.podeConfirmar ? "success" : "warning"',
                            size='small'
                        ) {{ scope.row.podeConfirmar ? 'Pronto' : 'Em análise' }}

                el-table-column(:label='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.contratosEnLote.colAcoes")', width='100', align='center')
                    template(slot-scope='scope')
                        el-button(
                            type='text',
                            size='small',
                            icon='el-icon-edit',
                            @click='editar(scope.row)'
                        ) {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.uploadRecebimentosLote.contratosEnLote.botaoEditar') }}

        footer.modal-contratos-en-lote-ar__footer(slot='footer')
            el-button(
                @click='fecharModal',
                :disabled='carregando'
            ) Fechar
            el-button(
                type='primary',
                :loading='carregando',
                :disabled='!temContratos',
                @click='confirmar'
            ) Confirmar
</template>

<script>
export default {
    name: 'ModalContratosEnLoteAr',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        contratos: {
            type: Array,
            default: () => []
        },
        carregando: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        temContratos() {
            return this.contratos.length > 0;
        }
    },

    methods: {
        formatarVolume(value) {
            if (value == null) { return '-'; }
            return value.toString().replace('.', ',');
        },

        tipoTagStatus(codigo) {
            if (!codigo) return 'info';
            if (['CONCLUIDO', 'PROCESSADO'].includes(codigo)) return 'success';
            if (codigo === 'EM_ANDAMENTO_REQUER_ATENCAO') return 'danger';
            if (codigo === 'EM_ANDAMENTO_VOLUME_INCONPLETO') return 'warning';
            return 'info';
        },

        tipoTagElegibilidade(codigo) {
            if (codigo === 'ELEGIVEL') return 'success';
            if (codigo === 'INELEGIVEL') return 'danger';
            if (codigo === 'ALERTA') return 'warning';
            return 'info';
        },

        editar(contrato) {
            this.$emit('editar', contrato);
        },

        confirmar() {
            if (this.carregando) return;
            this.$emit('confirmar');
        },

        fecharModal() {
            if (this.carregando) return;
            this.$emit('close');
        }
    }
};
</script>

<style lang="scss">
    .modal-contratos-en-lote-ar-content {
        max-width: 1280px;

        .el-dialog__header {
            padding: 16px 20px;
            background: var(--primary) !important;
            color: var(--white);
        }

        .el-dialog__headerbtn .el-dialog__close {
            color: var(--white);
        }

        .el-dialog__body {
            padding: 20px;
            word-break: break-word;
        }

        .modal-contratos-en-lote-ar__body {
            display: flex;
            flex-direction: column;
            gap: 16px;
            max-height: 70vh;
            overflow-y: auto;
            padding-right: 4px;
        }

        .modal-contratos-en-lote-ar__footer {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
        }
    }

    @media (max-width: 900px) {
        .modal-contratos-en-lote-ar-content {
            width: 96% !important;
        }
    }

.territorios-vinculados__empty {
    padding: 12px 20px 16px 40px;
    color: var(--gray, #999);
    font-size: 13px;
    font-style: italic;
}

.territorios-vinculados {
    padding: 12px 20px 16px 40px;

    &__header {
        display: flex;
        align-items: center;
        gap: 6px;
        font-weight: 600;
        font-size: 13px;
        color: var(--primary);
        margin-bottom: 10px;

        i.mdi {
            font-size: 16px;
        }
    }

    .el-table {
        border-radius: 4px;
    }
}
</style>
